import { Select as AntSelect } from 'antd';
import { SelectProps } from 'antd';
import styled from 'src/theme';

const { Option } = AntSelect;

const Select = styled((props: SelectProps<string>) => <AntSelect {...props} getPopupContainer={trigger => trigger}/>)`
  &.ant-select:not(.ant-select-customize-input).ant-select-focused:not(.ant-select-disabled) .ant-select-selector,
  &.ant-select:not(.ant-select-disabled):hover .ant-select-selector,
  &.ant-select-open .ant-select-selector,
  .ant-select-selector:focus,
  .ant-select-selector:active,
  .ant-select-selector:hover {
    border-color: ${props => props.theme.colors.orange} !important;
    box-shadow: none !important;
  }
  .ant-select-item-option-active,
  .ant-select-item-option-active:hover,
  .ant-select-item-option-selected {
    background-color: ${props => props.theme.colors.crusta} !important;
    color: white !important;
    font-weight: normal !important;
  }
  .ant-select-item-option-active:hover {
    font-weight: bold !important;
  }
`;

export { Select, Option };
